<template>
  <md-card>
    <md-card-header
      class="md-card-header-icon"
      :class="[valid === true ? 'md-card-header-green' : 'md-card-header-rose']"
    >
      <div class="card-icon">
        <md-icon>{{valid === true ? 'check' : 'close'}}</md-icon>
      </div>
      <h4 class="title">{{cardtitle}}</h4>
    </md-card-header>

    <md-card-content>
      <md-table
        :value="queriedData"
        :md-sort.sync="currentSort"
        :md-sort-order.sync="currentSortOrder"
        :md-sort-fn="customSort"
        class="paginated-table table-striped table-hover"
      >
        <md-table-toolbar>
          <md-field>
            <label for="pages">{{$lang.inputs.number_of_rows}}</label>
            <md-select v-model="pagination.perPage" name="pages">
              <md-option
                v-for="item in pagination.perPageOptions"
                :key="item"
                :label="item"
                :value="item"
              >{{ item }}</md-option>
            </md-select>
          </md-field>

          <md-field>
            <label>{{$lang.inputs.search}}</label>
            <md-input
              type="search"
              class="mb-2"
              clearable
              style="max-width: 150px"
              v-model="searchQuery"
            ></md-input>
          </md-field>
        </md-table-toolbar>

        <md-table-row slot="md-table-row" slot-scope="{ item }">
          <md-table-cell :md-label="$lang.titles.generated" md-sort-by="generated">{{item.generated}}</md-table-cell>
          <md-table-cell :md-label="$lang.titles.expiration" md-sort-by="expiration">{{item.expiration}}</md-table-cell>

          <md-table-cell :md-label="$lang.titles.token">
            <span
              style="cursor: pointer;"
              v-clipboard:copy="item.token_full"
              v-clipboard:success="copied"
              :title="$lang.messages.copy_token_to_clipboard"
            >{{item.token_short}}</span>
          </md-table-cell>

          <md-table-cell :md-label="$lang.titles.note">
            <md-field>
              <md-input
                v-model="item.note"
                type="text"
                :placeholder="$lang.inputs.write_note"
                @keyup.enter.native="saveNote($event, item)"
              ></md-input>
            </md-field>
          </md-table-cell>

          <md-table-cell>
            <md-button
              class="md-just-icon md-simple"
              v-clipboard:copy="item.token_full"
              v-clipboard:success="copied"
              :title="$lang.messages.copy_token_to_clipboard"
            >
              <i class="far fa-clone"></i>
            </md-button>
          </md-table-cell>
        </md-table-row>
      </md-table>
    </md-card-content>

    <md-card-actions md-alignment="space-between">
      <div class>
        <p class="card-category">{{$lang.general.showing}} {{ from + 1 }} - {{ to }} {{$lang.general.of}} {{ total }} {{$lang.general.rows}}</p>
      </div>
      <pagination
        class="pagination-no-border pagination-success"
        v-model="pagination.currentPage"
        :per-page="pagination.perPage"
        :total="total"
      ></pagination>
    </md-card-actions>
    <snack-bar ref="snackbar"></snack-bar>
  </md-card>
</template>


<script>
import axios from "axios";
import { getUserToken, getSelectedDeviceToken } from "@/storage/memoryStorage";
import snackBar from "@/components/SnackBar";
import { Pagination } from "@/components";
import Fuse from "fuse.js";

export default {
  name: "tokens-table",
  components: {
    Pagination,
    snackBar
  },

  props: {
    cardtitle: "",
    valid: {
      type: Boolean,
      default: true
    },
    tableData: {
      type: Array,
      default: []
    }
  },

  data() {
    return {
      currentSort: "generated",
      currentSortOrder: "asc",
      pagination: {
        perPage: 5,
        currentPage: 1,
        perPageOptions: [5, 10, 25, 50],
        total: 0
      },
      searchQuery: "",
      searchedData: [],
      fuseSearch: null
    };
  },

  computed: {
    selectedDevice() {
      return this.$store.getters.getSelectedDevice;
    },
    queriedData() {
      let result = this.tableData;
      if (this.searchedData.length > 0) {
        result = this.searchedData;
      }
      return result.slice(this.from, this.to);
    },
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total() {
      return this.searchedData.length > 0
        ? this.searchedData.length
        : this.tableData.length;
    }
  },

  watch: {
    searchQuery(value) {
      let result = this.tableData;
      if (value !== "") {
        result = this.fuseSearch.search(this.searchQuery);
      }
      this.searchedData = result;
    }
  },

  mounted() {
    this.fuseSearch = new Fuse(this.tableData, {
      keys: ["generated", "expiration"],
      threshold: 0.3
    });
  },

  methods: {
    saveNote(event, item) {
      event.target.blur();

      axios({
        method: "PUT",
        url: this.$ENDPOINTS.API_W + "/tools/integration",
        data: {
          user_token: getUserToken(),
          device_token: getSelectedDeviceToken(this.selectedDevice.mac),
          ID: item.ID,
          note: item.note
        },
        withCredentials: true
      })
        .then(response => {})
        .catch(error => {
          if (error.response) {
            this.$refs.snackbar.notify(
              this.$lang.messages.api_communication_error
            );
          }
        });
    },

    copied() {
      this.$refs.snackbar.notify(this.$lang.messages.token_copied);
    },

    customSort(value) {
      return value.sort((a, b) => {
        const sortBy = this.currentSort;
        if (this.currentSortOrder === "desc") {
          return a[sortBy].localeCompare(b[sortBy]);
        }
        return b[sortBy].localeCompare(a[sortBy]);
      });
    }
  }
};
</script>

<style lang="scss" scoped>
</style>